import { apiClient } from "./apiClient";

export async function gql({ query, variables, authMode }) {
  const result = await apiClient.graphql({
    query,
    variables,
    ...(authMode ? { authMode } : {}),
  });

  if (result.errors && result.errors.length) {
    const msg = result.errors
      .map((e) => e.message || JSON.stringify(e))
      .join(", ");
    throw new Error(`GraphQL error: ${msg}`);
  }

  return result.data;
}

export async function fetchAllPagesWithGql({
  queryDoc,
  fieldName,
  variablesBase = {},
  pageSize = 1000,
  authMode,
}) {
  let items = [];
  let nextToken;

  do {
    const variables = {
      ...(variablesBase || {}),
      limit: pageSize,
      ...(nextToken ? { nextToken } : {}),
    };

    const res = await gql({ query: queryDoc, variables, authMode });
    const container = res?.[fieldName];

    container.items.forEach((element) => {
      items.push(element);
    });

    nextToken = container.nextToken;
  } while (nextToken);
  return items;
}
